import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d7bcd1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"background-color":"white"},
  class: "searchbar mt-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fas fa-search searchbar__icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-undo",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Back", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "No Results Found", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "No Results Found", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["searchbar__control", {'searchbar__control--members': _ctx.page !== 'blog'}])
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        class: "searchbar__input",
        placeholder: _ctx.description,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onKeydown: [
          _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
          _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
          _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["prevent"]), ["enter"]))
        ],
        type: "search"
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.search]
      ]),
      (_ctx.showReset)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "autocomplete-reset",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetSearch && _ctx.resetSearch(...args)), ["stop"])),
            "aria-label": "Return to previous search",
            title: "Return to previous search"
          }, _hoisted_6))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.page!='blog')
      ? _withDirectives((_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(_ctx.results.length < 1 ? 'autocomplete-results-empty' : 'autocomplete-results')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              onClick: ($event: any) => (_ctx.setResult(result)),
              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }])
            }, _toDisplayString(_ctx.autocompleteResultLabel(result)), 11, _hoisted_7))
          }), 128)),
          (_ctx.results.length < 1)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ], 2)), [
          [_vShow, _ctx.isOpen]
        ])
      : _createCommentVNode("", true),
    (_ctx.page=='blog')
      ? _withDirectives((_openBlock(), _createElementBlock("ul", {
          key: 1,
          class: _normalizeClass(_ctx.results.length < 1 ? 'autocomplete-results-empty' : 'autocomplete-results')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              onClick: ($event: any) => (_ctx.setResult(result)),
              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }])
            }, _toDisplayString(_ctx.blogResultLabel(result)), 11, _hoisted_11))
          }), 128)),
          (_ctx.results.length < 1)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true)
        ], 2)), [
          [_vShow, _ctx.isOpen]
        ])
      : _createCommentVNode("", true)
  ]))
}